<template lang="pug">
.engineering-requests
	.request-container(v-for='request in requests' v-if='requests.length != 0')
		.request-title(@click="openDocument(request.file, request.folder)")
			p Request
				span  {{ request.number }}

		.person-info
			.icon-person-outlined
			p {{ request.requestingParty }} - {{ dateFormat( request.createdAt, 'MMMM DD, YYYY' ) }}

		.summary
			p {{ request.summary }}

	p.spacey(v-if='requests.length === 0') No Requests To Show
</template>

<script>
import { FormatDate } from '@/lib/utils';

export default {
	name : 'engineering-requests',

	props : {
		job : {
			type : [Object, Array],
		},

		requests : {
			type : Array,
		},
	},

	data : () => ( {

	} ),

	methods : {

		dateFormat( val, format ) {
			return FormatDate( val, format );
		},

		openDocument( file, folder ) {
			const filePath = `${folder}/${file}`;

			this.$store.dispatch( 'openDocument', filePath );
		}

	}
};
</script>

<style lang='scss'>
.engineering-requests {
	padding: 0 50px;

	.request-container {
		display: flex;
		flex-flow: column;
		align-items: flex-start;
		margin-top: 25px;
		box-shadow: 0px 2px 14px rgba(80, 96, 110, 0.25), 0px 0px 6px rgba(80, 96, 110, 0.1);
		border-radius: 15px;
		padding: 20px;
		background: white;

		.request-title {
			cursor: pointer;
			p {
				color: rgba( $color-primary, .7 );
				font-size: 24px;
				font-weight: 500;
				text-align: left;

				span {
					color: $color-primary;
				}
			}
		}

		.person-info {
			display: flex;
			flex-flow: row nowrap;
			align-items: center;
			margin-top: 5px;

			.icon-person {
				display: flex;
				flex-flow: column;
				align-items: center;
				justify-content: center;
				color: $input-color;
				border: 2px solid $input-color;
				border-radius: 50%;
				padding: 5px;
				height: 25px;
				width: 25px;
				font-size: 12px;
			}

			.icon-person-outlined {
				font-size: 18px;

				&::before {
					color: $input-color;
				}
			}

			p {
				color: $input-color;
				margin-left: 10px;
				font-weight: 500;
				font-size: 14px;
				text-align: left;
			}
		}

		.summary {
			font-size: 14px;
			font-weight: 300;
			text-align: left;
			margin-top: 15px;
		}
	}

	p.spacey {
		text-align: center;
		margin-top: 30px;
	}
}
</style>
